import { createFileRoute } from '@tanstack/react-router';

import { WorkloadCategoriesView } from '../../../features/workload-categories/workload-categories-view';

export const Route = createFileRoute('/admin/workload-categories/')({
  staticData: { breadcrumb: 'Workload Categories' },
  component: WorkloadCategoriesView,
});
